import Box from '@mui/material/Box';
import {
  ButtonBox,
  SpinnerWrapper,
  TutorsLoaderGrid,
} from './tutoringV2Styled';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { TabButton } from 'components/Ui/styled';
import MDTypography from 'components/MDTypography';
import { ButtonSpinner } from 'components/Ui/styled';
import { ButtonSpinnerProgress } from 'components/Ui/styled';
import CircularProgress from '@mui/material/CircularProgress';

export const TutoringV2TabItem = ({ tab, isSelected, onSelect }) => {
  const { key, label, icon } = tab;

  return (
    <TabButton
      disableRipple
      selected={isSelected}
      onClick={() => onSelect(key)}
    >
      <Box display="flex" alignItems="center" gap={1}>
        {icon}
        {label}
      </Box>
    </TabButton>
  );
};

export const CreateNewSubjectButton = ({ label, handleClick }) => {
  return (
    <ButtonBox>
      <Button onClick={handleClick} variant="text">
        {label}
      </Button>
    </ButtonBox>
  );
};

export const ManageTutorsCategoryData = ({ label, value }) => {
  return (
    <Grid container spacing={0} alignItems="flex-start">
      {/* Label */}
      <Grid item xs={1.1}>
        <MDTypography
          variant="button"
          component="span"
          fontWeight="bold"
          textTransform="capitalize"
        >
          {label}
        </MDTypography>
      </Grid>

      {/* Value */}
      <Grid item xs={9}>
        <MDTypography
          color="text"
          variant="button"
          component="span"
          fontWeight="regular"
        >
          {value}
        </MDTypography>
      </Grid>
    </Grid>
  );
};

export const TutorsDialogLoader = () => {
  return (
    <TutorsLoaderGrid item xs={12} py={2}>
      <CircularProgress size={32} />
    </TutorsLoaderGrid>
  );
};

export const ButtonWithLoader = ({ label, onClick, loading, disabled }) => {
  return (
    <ButtonSpinner>
      <SpinnerWrapper>
        <Button
          fullWidth
          variant="outlined"
          disabled={disabled}
          onClick={onClick}
        >
          {label}
        </Button>
        {loading && <ButtonSpinnerProgress size={24} />}
      </SpinnerWrapper>
    </ButtonSpinner>
  );
};
